import { gql } from "@apollo/client";

export const UPDATE_GROUP = gql`
  mutation updateGroup($input: UpdateSkynetUserGroupInput!) {
    rolesAndPermissions {
      updateGroup(input: $input) {
        success
      }
    }
  }
`;
